import { h } from '../lib/dom.js';
import { getState } from '../store.js';
import { cancelMainnetSwitch, confirmMainnetSwitch } from '../actions.js';
import { t } from '../i18n/index.js';

// Explicit, visually distinct confirmation for *enabling* mainnet
// (CLAUDE.md — see store.js's showMainnetConfirm comment). Reuses the same
// red used by the header's existing MAINNET badge so the two read as one
// consistent "this is the real-funds state" signal, not two unrelated reds.
export function renderMainnetConfirmModal() {
  const s = getState();
  if (!s.showMainnetConfirm) return null;

  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card mainnet-confirm-card' }, [
      h('div', { class: 'mainnet-confirm-badge' }, t('modals.mainnetConfirm.badge')),
      h('div', { class: 'modal-title' }, t('modals.mainnetConfirm.title')),
      h('div', { class: 'text-sm text-muted' }, t('modals.mainnetConfirm.body')),
      h('div', { class: 'btn-row' }, [
        h('button', { class: 'btn btn-secondary', onclick: cancelMainnetSwitch }, t('common.cancel')),
        h('button', { class: 'btn btn-danger btn-emphasis', onclick: confirmMainnetSwitch }, t('modals.mainnetConfirm.switchToMainnet'))
      ])
    ])
  ]);
}
